import type { Map } from 'leaflet'
import { FC } from 'react'
import { useIsEmbedded } from '../../../contexts/ui'
import DrawTool from '../../../../pages/MapPage/components/DrawTool/DrawTool'

const DrawToolControl: FC<{ map: Map }> = ({ map }) => {
  const isEmbedded = useIsEmbedded()

  if (isEmbedded) {
    return null
  }

  return (
    <div data-testid="drawtoolControl">
      <DrawTool map={map} />
    </div>
  )
}

export default DrawToolControl
